import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxInputProjektStatus from '../Inputs/CheckBoxInputProjektStatus'
import CheckBoxInputProjektFas from '../Inputs/CheckBoxInputProjektFas'
import CheckBoxInputProjektType from '../Inputs/CheckBoxInputProjektType'
import CheckBoxInputAnsvarig from '../Inputs/CheckBoxInputAnsvarig'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import IntlMessages from 'util/IntlMessages';

function ProjektSection(props) {
    const CurrentObjekt = useSelector(state => state.accountsData.CurrentObjekt)
    const Flags = useSelector(state => state.accountsData.Flags) 
    const onChangeMstate=(Chips)=>{
        console.log(Chips)
    }
    return (<>
           <Grid container direction="row" alignItems="center" className='mt-2 pt-2 pl-2' style={{maxHeight:460,minHeight:120,overflowY:"auto"}}>
           <Grid item  className={"pt-1"}  xs={12} md={12} ><IntlMessages id="Project"/></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="ProjektNr"  MetaN={"Projekt_ProjectNr"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="ProjektName"  MetaN={"Projekt_ProjectName"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputProjektStatus Meta="Status"  MetaN={"Projekt_Status"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputProjektFas Meta="Fas"  MetaN={"Projekt_Fas"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Anteckning" MetaN={"Projekt_Kommentar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kalkylerade timmar" MetaN={"Projekt_KalkyleradeTimmar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Medarbetare"  MetaN={"Projekt_Medarbetare"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Ägare"  MetaN={"Projekt_Ansvarig"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Taggar"  MetaN={"Projekt_Taggar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Skapad datum"  MetaN={"Projekt_SkapadDatum"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Deadline"  MetaN={"Projekt_deadline"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Start"  MetaN={"Projekt_StartDatum"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
            <Grid item className={"pt-1"}  xs={12} md={12} ><IntlMessages id="Label.projectTime"/></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Tid Användare" MetaN={"Projekt_Tid_user"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputProjektType Meta="TidTyp" MetaN={"Projekt_Tid_Typ"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kategori" MetaN={"Projekt_Tid_Kategori"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>         
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Arbetade timmar" MetaN={"Projekt_Tid_ArbetadeTimmar"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Fakturerbara timmar" MetaN={"Projekt_Tid_FakturerbaraTimmar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Tid Kommentar" MetaN={"Projekt_Tid_Kommentar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
          
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Registrerad" MetaN={"Projekt_Tid_Registrerad"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Tidstart" MetaN={"Projekt_Tid_Start"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="TidEnd" MetaN={"Projekt_Tid_End"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           </Grid>
        </>
    );
}

export default ProjektSection;
